module.exports = __webpack_public_path__ + "img/appltCourse-img15.a269864b.png";